import React from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


export const Testimonial = () => {
    var setting = {
        infinite: false,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 3,
        arrows:false,
        dots:true,
        }
    return (
        <section className="testimonials">
            <div className="container container1636">
                <div className="testimonial">
                    <div className="title">
                        <h3>Testimonial</h3>
                        <h2>What Our Customer Said</h2>
                        <p>These are just a few of the testimonial that GMI68 Cambodia has received.</p>
                    </div>
                    <div className="testimonial-slide">
                        <Slider {...setting}>
                                <div className="slick-child">
                                    <div className="box-list">
                                        <div className="list">
                                            <img src={require('../../images/GMi68-international-nomad-cambodia-product-testimonail-02.jpg')} alt="" />
                                        </div>
                                        <h3>Pak Serge</h3>
                                        <p>CEO - Beton Block and Pave</p>
                                        <p className="title">
                                            I am living in Udong. Before, when I wanted to change tires, I had to come to Phnom Penh, but now I don't have to come, which takes a lot of time & money. I can change my tires at GMi68 dealer near my factory.
                                        </p>
                                    </div>
                                </div>
                                <div className="slick-child">
                                    <div className="box-list">
                                        <div className="list">
                                            <img src={require('../../images/GMi68-international-nomad-cambodia-product-testimonail.jpg')} alt="" />
                                        </div>
                                        <h3>CHAN Narong</h3>
                                        <p>Managing Director - Cool Freight & Logistics</p>
                                        <p className="title">
                                            I just a bought new car, and he gave me a good recommendation for new wheel changing and tire-using, so I really love the sport-car-type rim and tire and my car look nice and fashion. Recommended his company and service.
                                        </p>
                                    </div>
                                </div>
                                <div className="slick-child">
                                    <div className="box-list">
                                        <div className="list">
                                            <img src={require('../../images/GMi68-international-nomad-cambodia-product-testimonail-01.jpg')} alt="" />
                                        </div>
                                        <h3>Pak Serge</h3>
                                        <p>CEO - Beton Block and Pave</p>
                                        <p className="title">
                                            As I was en route from Mondulkiri to Ratanakiri province. My tires were broken, and then I just call GMi68. They promptly come and change. I really like their service and help me quickly. Finally, I can continue my trip with safety and fun.
                                        </p>
                                    </div>
                                </div>
                                <div className="slick-child">
                                    <div className="box-list">
                                        <div className="list">
                                            <img src={require('../../images/GMi68-international-nomad-cambodia-product-testimonail-02.jpg')} alt="" />
                                        </div>
                                        <h3>Pak Serge</h3>
                                        <p>CEO - Beton Block and Pave</p>
                                        <p className="title">
                                            I am living in Udong. Before, when I wanted to change tires, I had to come to Phnom Penh, but now I don't have to come, which takes a lot of time & money. I can change my tires at GMi68 dealer near my factory.
                                        </p>
                                    </div>
                                </div>
                                <div className="slick-child">
                                    <div className="box-list">
                                        <div className="list">
                                            <img src={require('../../images/GMi68-international-nomad-cambodia-product-testimonail.jpg')} alt="" />
                                        </div>
                                        <h3>CHAN Narong</h3>
                                        <p>Managing Director - Cool Freight & Logistics</p>
                                        <p className="title">
                                            I just a bought new car, and he gave me a good recommendation for new wheel changing and tire-using, so I really love the sport-car-type rim and tire and my car look nice and fashion. Recommended his company and service.
                                        </p>
                                    </div>
                                </div>
                                <div className="slick-child">
                                    <div className="box-list">
                                        <div className="list">
                                            <img src={require('../../images/GMi68-international-nomad-cambodia-product-testimonail-01.jpg')} alt="" />
                                        </div>
                                        <h3>Pak Serge</h3>
                                        <p>CEO - Beton Block and Pave</p>
                                        <p className="title">
                                            As I was en route from Mondulkiri to Ratanakiri province. My tires were broken, and then I just call GMi68. They promptly come and change. I really like their service and help me quickly. Finally, I can continue my trip with safety and fun.
                                        </p>
                                    </div>
                                </div>
                        </Slider>
                    </div>
                </div>
            </div>
        </section>
    )
}